<template>
  <modal v-bind="$attrs" v-on="$listeners" :title="getTitle">
    <template v-slot:body>
      <p>
        {{
          $t('organizations.users_section.modals.delete.message', {
            numberOfAccounts: numberOfSelectedUsers
          })
        }}
      </p>
      <p>
        <el-checkbox class="elsa-checkbox flex justify-center flex-row" label="consent" v-if="isElsaAdmin" v-model.lazy="isRemoveUserFromSystem">
          {{ $t('common.remove_user_from_system') }}
        </el-checkbox>
      </p>
    </template>
    <template v-slot:footer>
      <span class="dialog-footer">
        <primary-button class="confirm-delete" ref="submitEditOrganizationUserButton" @click.native="handleSubmitDeleteUsers">
          {{ $t('organization_profile.remove_admin_modal.yes_remove') }}
        </primary-button>
        <tertiary-button @click.native="$emit('closed')">
          {{ $t('organization_profile.remove_admin_modal.no_cancel') }}
        </tertiary-button>
      </span>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import { mapGetters } from 'vuex'
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import TertiaryButton from '@/components/common/buttons/TertiaryButton'

export default {
  props: {
    numberOfSelectedUsers: {
      type: Number,
      default: 1
    }
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton
  },
  data() {
    return {
      isRemoveUserFromSystem: false
    }
  },
  computed: {
    ...mapGetters('user', ['isElsaAdmin']),
    ...mapGetters('organization', ['isOrganizationAdmin']),
    getTitle() {
      return this.$t('organizations.users_section.modals.delete.title', {
        numberOfAccounts: this.numberOfSelectedUsers
      })
    }
  },
  methods: {
    handleSubmitDeleteUsers() {
      this.$emit('closed')
      this.$emit('doRemoveStudentFromOrg', this.isRemoveUserFromSystem)
    }
  },
  mounted() {
    if (this.isElsaAdmin) this.isRemoveUserFromSystem = true
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
p {
  margin: 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  color: #eb5757;
}
.elsa-button.confirm-delete,
.elsa-button.confirm-delete:hover {
  background: $orange;
  border-radius: 8px;
}
.elsa-checkbox {
  width: 100%;
  flex-direction: row !important;
  ::v-deep {
    .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }

    .el-checkbox__inner::after {
      height: 7px;
      left: 4px;
    }
  }
}
</style>
